import React from 'react';
import PropTypes from 'prop-types';
import {
  Icon,
} from 'semantic-ui-react';
import { SortableHandle } from 'react-sortable-hoc';

const SortableDragHandle = SortableHandle(({
  iconClass,
  iconColor,
  iconName,
  iconSize,
  iconDisabled,
}) => (
  <Icon
    className={`dragicon ${iconClass}`}
    color={iconColor}
    disabled={iconDisabled}
    name={iconName}
    size={iconSize}
  />
));

SortableDragHandle.propTypes = {
  iconClass: PropTypes.string,
  iconColor: PropTypes.string,
  iconName: PropTypes.string,
  iconSize: PropTypes.string,
  iconDisabled: PropTypes.bool,
};

SortableDragHandle.defaultProps = {
  iconClass: '',
  iconColor: null,
  iconName: 'content',
  iconSize: 'large',
  iconDisabled: true,
};

export default SortableDragHandle;



// WEBPACK FOOTER //
// ./src/components/Sortable/SortableDragHandle.jsx